import React from "react";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";

const VideoModal = ({ show, onHide, videoId }) => {
	return (
		<Modal className="video-modal" show={show} onHide={onHide}>
			<Modal.Body>
				<ReactPlayer url={`https://www.youtube.com/watch?v=${videoId}`} width="100%" height="100%" playing controls />
			</Modal.Body>
		</Modal>
	);
};

export default VideoModal;
